var i = /* @__PURE__ */ ((d) => (d.image = "image", d.video = "video", d.pdf = "pdf", d.audio = "audio", d))(i || {});
export {
  i as ResourceType
};
//# sourceMappingURL=propsTypes.js.map
